import * as React from 'react';

import HtmlContent from '../../util/HtmlContent';
import MenuContent from '../../util/MenuContent';
import { Box } from '@mui/material';
import CodeContentPage from './CodeContentPage';
import LinhaContent from '../../util/LinhaContent';
import ColunaContent from '../../util/ColunaContent';
import Service from '../../../util/Service';
import { useNavigate } from 'react-router-dom';
import PaginaHtmlDinamica from '../PaginaHtmlDinamica';

export default function ContentPage(props) {
    const { pagina, edit, darkMode } = props;
    const navigate = useNavigate();
    const [pg, setPg] = React.useState();

    function buscaPagina(id) {
        Service.GET("/api/paginaHtml/buscaPorId/" + id).then(r => setPg(r));
    }
    if( typeof pagina === 'string'){
        if (pagina) {
            if( pg){
                return (
                    <ContentPage pagina={pg} edit={edit} />
                )
            }
            if (pagina.charAt(0) === "/") {
                setTimeout(() => {
                    navigate(pagina);    
                }, 300);                
                return (<p>Aguarde....</p>)                
            } else if (pagina.toUpperCase().indexOf("HTTP") >= 0) {
                return (<p>Aguarde....2</p>)                
            } else {
                buscaPagina(pagina);
                return(
                    <p>Aguarde....</p>
                )
            }
        }
    }
    if (!pagina) {
        return (<br />);
    }
    if (pagina.menu) {
        return (
            <MenuContent menuJson={pagina.menu} darkMode={darkMode} />
        )
    }
    if (pagina.pagina) {
        
        if( pagina.controller){
            return (
                <PaginaHtmlDinamica rootPage={pagina} edit={edit} />
            )    
        }
        return (
            <HtmlContent htmlString={pagina ? pagina.pagina : ''} edit={edit} />
        )
    }
    if (pagina.codigo) {
        return (
            <Box sx={{ flexGrow: 1 }}>
                {pagina.codigo.blocks.map((row, index) => {                    
                    return (
                        <CodeContentPage
                            key={index} bloco={row} pagina={pagina} 
                        />
                    )
                })}
            </Box>
        )
    }

    if( pagina.layout?.linha && pagina.layout.tipo === "linha"){
        return (
            <LinhaContent pagina={pagina} edit={edit} darkMode={edit} />
        )
    }
    if( pagina.layout?.coluna && pagina.layout.tipo === "coluna"){
        return (
            <ColunaContent pagina={pagina} edit={edit} darkMode={edit} />
        )
    }
    return (
        <p>Não implementado...</p>
    )
}